<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
    <!--begin::Toolbar container-->
    <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <!--begin::Title-->
            <div class="d-flex align-items-center">
                <h1 class="page-heading">
                    <svg width="35" height="33" viewBox="0 0 35 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g filter="url(#filter0_d_645_5489)">
                            <path
                                d="M30.478 18.7855L21.0745 2.09517C20.3377 0.78125 19.0044 0 17.4956 0C15.9868 0 14.6535 0.78125 13.9167 2.09517L4.54832 18.7855C3.81148 20.0994 3.81148 21.6264 4.58341 22.9403C5.32024 24.2543 6.65357 25 8.12725 25H26.8991C28.3727 25 29.7061 24.2188 30.4429 22.9403C31.1797 21.6619 31.1797 20.0994 30.478 18.7855ZM18.2325 19.9574C18.2325 20.4545 17.8465 20.8452 17.3553 20.8452C16.864 20.8452 16.4781 20.4545 16.4781 19.9574V18.5369C16.4781 18.0398 16.864 17.6491 17.3553 17.6491C17.8465 17.6491 18.2325 18.0398 18.2325 18.5369V19.9574ZM18.2325 15.696C18.2325 16.1932 17.8465 16.5838 17.3553 16.5838C16.864 16.5838 16.4781 16.1932 16.4781 15.696V8.23864C16.4781 7.74148 16.864 7.35085 17.3553 7.35085C17.8465 7.35085 18.2325 7.74148 18.2325 8.23864V15.696Z"
                                fill="#265D91" />
                        </g>
                        <defs>
                            <filter id="filter0_d_645_5489" x="0" y="0" width="35" height="33"
                                filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                                <feColorMatrix in="SourceAlpha" type="matrix"
                                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                <feOffset dy="4" />
                                <feGaussianBlur stdDeviation="2" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_645_5489" />
                                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_645_5489"
                                    result="shape" />
                            </filter>
                        </defs>
                    </svg>

                    Alerte
                </h1>

                <!--begin::Menu-->

            </div>
            <!--end::Title-->
            <!--begin::Breadcrumb-->
            <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">
                    <a href="/accueil" class="text-muted text-hover-primary">Accueil</a>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <!--end::Item-->
                <!--begin::Item-->
                <li class="breadcrumb-item text-muted">Alerte</li>
                <li class="breadcrumb-item">
                    <span class="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <li class="breadcrumb-item text-muted">Appels d’offres</li>
                <!--end::Item-->
            </ul>
            <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
    </div>
    <!--end::Toolbar container-->
</div>
<div id="kt_app_content" class="app-content flex-column-fluid mb-4">
    <!--begin::Content container-->
    <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card">
            <!--begin::Card header-->

            <div class="card-body tools">
                <div class="title mb-15">
                    <h4>Alerts Appels d’offres </h4>
                </div>
                <div class="container">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <form class="w-100 position-relative" autocomplete="off">
                                <!--begin::Icon-->
                                <i class="ki-duotone ki-magnifier fs-3 text-gray-500 position-absolute top-50 ms-5 translate-middle-y">
                                    <span class="path1"></span>
                                    <span class="path2"></span>
                                </i>
                                <!--end::Icon-->
                                <!--begin::Input-->
                                <input type="text" class="form-control form-control-solid px-13 search" name="search" value="" placeholder="Rechercher ici " />
                                <!--end::Input-->
                            </form>
                        </div>
                        <div class="col-lg-3 rechercher">
                            <!-- <div class="btn_search">
                        <a href="#" class="search"> <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z" fill="white"/>
                            </svg>
                             Rechercher</a>
                       </div>     -->
                        </div>
                        <div class="col-lg-4">


                        </div>

                    </div>

                    <div class="table-responsive mt-15">
                        <table class="table align-middle fs-6 gy-5 table-style" id="list_cra">
                            <thead>
                                <th class="bg1">
                                    Offres
                                </th>
                                <th class="bg2">
                                    Candidats
                                </th>
                                <th class="bg2">
                                    Date de l'offre
                                </th>
                                <th class="bg3">
                                    Action
                                </th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><span>Offre 1</span></td>
                                    <td>
                                        <span>Candidat 1 </span>
                                    </td>
                                    <td>
                                        <span>12/05/2023</span>
                                    </td>
                                    <td class="actions">
                                        <div class="tools">
                                            <div class="dropdown">
                                                <button
                                                    class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle btn-t"
                                                    type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                                    aria-haspopup="true" aria-expanded="false">
                                                    <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91" />
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                            fill="#265D91" />
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                            fill="#265D91" />
                                                    </svg>
                                                </button>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <a class="dropdown-item">Voir détail</a>
                                                    <a routerLink="/alerts/liste-vue-appel-offre" class="dropdown-item">Historique des vues sur les offres </a>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span>Offre 1</span></td>
                                    <td>
                                        <span>Candidat 1 </span>
                                    </td>
                                    <td>
                                        <span>12/05/2023</span>
                                    </td>
                                    <td class="actions">
                                        <div class="tools">
                                            <div class="dropdown">
                                                <button
                                                    class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle btn-t"
                                                    type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                                    aria-haspopup="true" aria-expanded="false">
                                                    <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91" />
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                            fill="#265D91" />
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                            fill="#265D91" />
                                                    </svg>
                                                </button>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <a class="dropdown-item">Voir détail</a>
                                                    <a routerLink="/alerts/liste-vue-appel-offre" class="dropdown-item">Historique des vues sur les offres </a>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span>Offre 1</span></td>
                                    <td>
                                        <span>Candidat 1 </span>
                                    </td>
                                    <td>
                                        <span>12/05/2023</span>
                                    </td>
                                    <td class="actions">
                                        <div class="tools">
                                            <div class="dropdown">
                                                <button
                                                    class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle btn-t"
                                                    type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                                    aria-haspopup="true" aria-expanded="false">
                                                    <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91" />
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                            fill="#265D91" />
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                            fill="#265D91" />
                                                    </svg>
                                                </button>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <a class="dropdown-item">Voir détail</a>
                                                    <a routerLink="/alerts/liste-vue-appel-offre" class="dropdown-item">Historique des vues sur les offres </a>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span>Offre 1</span></td>
                                    <td>
                                        <span>Candidat 1 </span>
                                    </td>
                                    <td>
                                        <span>12/05/2023</span>
                                    </td>
                                    <td class="actions">
                                        <div class="tools">
                                            <div class="dropdown">
                                                <button
                                                    class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle btn-t"
                                                    type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                                    aria-haspopup="true" aria-expanded="false">
                                                    <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91" />
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                            fill="#265D91" />
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                            fill="#265D91" />
                                                    </svg>
                                                </button>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <a class="dropdown-item">Voir détail</a>
                                                    <a routerLink="/alerts/liste-vue-appel-offre" class="dropdown-item">Historique des vues sur les offres </a>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span>Offre 1</span></td>
                                    <td>
                                        <span>Candidat 1 </span>
                                    </td>
                                    <td>
                                        <span>12/05/2023</span>
                                    </td>
                                    <td class="actions">
                                        <div class="tools">
                                            <div class="dropdown">
                                                <button
                                                    class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle btn-t"
                                                    type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                                    aria-haspopup="true" aria-expanded="false">
                                                    <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91" />
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                            fill="#265D91" />
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                            fill="#265D91" />
                                                    </svg>
                                                </button>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <a class="dropdown-item">Voir détail</a>
                                                    <a routerLink="/alerts/liste-vue-appel-offre" class="dropdown-item">Historique des vues sur les offres </a>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span>Offre 1</span></td>
                                    <td>
                                        <span>Candidat 1 </span>
                                    </td>
                                    <td>
                                        <span>12/05/2023</span>
                                    </td>
                                    <td class="actions">
                                        <div class="tools">
                                            <div class="dropdown">
                                                <button
                                                    class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle btn-t"
                                                    type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                                    aria-haspopup="true" aria-expanded="false">
                                                    <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91" />
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                            fill="#265D91" />
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                            fill="#265D91" />
                                                    </svg>
                                                </button>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <a class="dropdown-item">Voir détail</a>
                                                    <a routerLink="/alerts/liste-vue-appel-offre" class="dropdown-item">Historique des vues sur les offres </a>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td><span>Offre 1</span></td>
                                    <td>
                                        <span>Candidat 1 </span>
                                    </td>
                                    <td>
                                        <span>12/05/2023</span>
                                    </td>
                                    <td class="actions">
                                        <div class="tools">
                                            <div class="dropdown">
                                                <button
                                                    class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle btn-t"
                                                    type="button" id="dropdownMenuButton" data-bs-toggle="dropdown"
                                                    aria-haspopup="true" aria-expanded="false">
                                                    <svg width="19" height="5" viewBox="0 0 19 5" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 0 4.89478)" fill="#265D91" />
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                                            fill="#265D91" />
                                                        <circle cx="2.44739" cy="2.44739" r="2.44739"
                                                            transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                                            fill="#265D91" />
                                                    </svg>
                                                </button>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <a class="dropdown-item">Voir détail</a>
                                                    <a routerLink="/alerts/liste-vue-appel-offre" class="dropdown-item">Historique des vues sur les offres </a>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                            </tbody>

                        </table>
                    </div>
                    <div class="pagination pt-3">
                        <svg width="141" height="21" viewBox="0 0 141 21" fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M133 4L139 10L133 16" stroke="#ACA7A7" stroke-width="2"
                                stroke-linecap="round" />
                            <path d="M8 4L2 10L8 16" stroke="#ACA7A7" stroke-width="2"
                                stroke-linecap="round" />
                            <path
                                d="M80.66 9.049C80.7113 8.37433 80.9717 7.84633 81.441 7.465C81.9103 7.08367 82.519 6.893 83.267 6.893C83.7657 6.893 84.1947 6.98467 84.554 7.168C84.9207 7.344 85.1957 7.586 85.379 7.894C85.5697 8.202 85.665 8.55033 85.665 8.939C85.665 9.39367 85.533 9.786 85.269 10.116C85.0123 10.446 84.675 10.6587 84.257 10.754V10.809C84.7337 10.9263 85.1113 11.1573 85.39 11.502C85.6687 11.8467 85.808 12.2977 85.808 12.855C85.808 13.273 85.7127 13.6507 85.522 13.988C85.3313 14.318 85.0453 14.5783 84.664 14.769C84.2827 14.9597 83.8243 15.055 83.289 15.055C82.5117 15.055 81.8737 14.8533 81.375 14.45C80.8763 14.0393 80.5977 13.46 80.539 12.712H81.507C81.5583 13.152 81.738 13.5113 82.046 13.79C82.354 14.0687 82.7647 14.208 83.278 14.208C83.7913 14.208 84.18 14.076 84.444 13.812C84.7153 13.5407 84.851 13.1923 84.851 12.767C84.851 12.217 84.6677 11.821 84.301 11.579C83.9343 11.337 83.3807 11.216 82.64 11.216H82.387V10.38H82.651C83.3257 10.3727 83.8353 10.2627 84.18 10.05C84.5247 9.83 84.697 9.49267 84.697 9.038C84.697 8.64933 84.5687 8.33767 84.312 8.103C84.0627 7.86833 83.7033 7.751 83.234 7.751C82.7793 7.751 82.4127 7.86833 82.134 8.103C81.8553 8.33767 81.6903 8.653 81.639 9.049H80.66Z"
                                fill="#7E7C7C" />
                            <rect x="24" y="1" width="19" height="19" rx="3" fill="#63C3E8" />
                            <rect x="48.75" y="0.75" width="19.5" height="19.5" rx="3.25"
                                stroke="#63C3E8" stroke-width="0.5" />
                            <rect x="73.75" y="0.75" width="19.5" height="19.5" rx="3.25"
                                stroke="#63C3E8" stroke-width="0.5" />
                            <path d="M32.54 7.5V6.252H35.036V15H33.656V7.5H32.54Z" fill="white" />
                            <path
                                d="M55.561 14.197C56.4923 13.449 57.222 12.8367 57.75 12.36C58.278 11.876 58.7217 11.3737 59.081 10.853C59.4477 10.325 59.631 9.808 59.631 9.302C59.631 8.82533 59.5137 8.45133 59.279 8.18C59.0517 7.90133 58.6813 7.762 58.168 7.762C57.6693 7.762 57.2807 7.91967 57.002 8.235C56.7307 8.543 56.584 8.95733 56.562 9.478H55.594C55.6233 8.65667 55.8727 8.02233 56.342 7.575C56.8113 7.12767 57.4163 6.904 58.157 6.904C58.9123 6.904 59.51 7.113 59.95 7.531C60.3973 7.949 60.621 8.52467 60.621 9.258C60.621 9.86667 60.4377 10.4607 60.071 11.04C59.7117 11.612 59.301 12.118 58.839 12.558C58.377 12.9907 57.7867 13.4967 57.068 14.076H60.852V14.912H55.561V14.197Z"
                                fill="#7E7C7C" />
                            <path
                                d="M106.166 15.066C105.975 15.066 105.814 15 105.682 14.868C105.55 14.736 105.484 14.5747 105.484 14.384C105.484 14.1933 105.55 14.032 105.682 13.9C105.814 13.768 105.975 13.702 106.166 13.702C106.349 13.702 106.503 13.768 106.628 13.9C106.76 14.032 106.826 14.1933 106.826 14.384C106.826 14.5747 106.76 14.736 106.628 14.868C106.503 15 106.349 15.066 106.166 15.066ZM108.476 15.066C108.285 15.066 108.124 15 107.992 14.868C107.86 14.736 107.794 14.5747 107.794 14.384C107.794 14.1933 107.86 14.032 107.992 13.9C108.124 13.768 108.285 13.702 108.476 13.702C108.659 13.702 108.813 13.768 108.938 13.9C109.07 14.032 109.136 14.1933 109.136 14.384C109.136 14.5747 109.07 14.736 108.938 14.868C108.813 15 108.659 15.066 108.476 15.066ZM110.785 15.066C110.594 15.066 110.433 15 110.301 14.868C110.169 14.736 110.103 14.5747 110.103 14.384C110.103 14.1933 110.169 14.032 110.301 13.9C110.433 13.768 110.594 13.702 110.785 13.702C110.968 13.702 111.122 13.768 111.247 13.9C111.379 14.032 111.445 14.1933 111.445 14.384C111.445 14.5747 111.379 14.736 111.247 14.868C111.122 15 110.968 15.066 110.785 15.066Z"
                                fill="#7E7C7C" />
                            <rect x="98.75" y="0.75" width="19.5" height="19.5" rx="3.25"
                                stroke="#63C3E8" stroke-width="0.5" />
                        </svg>
                    </div>
                </div>


            </div>
        </div>

    </div>
    <!--end::Content container-->
</div>